// cSpell: ignore putaoid,

import React from "react";
import PropTypes from 'prop-types';
import styled from 'styled-components';

import request from '../../lib/request';
import { reqAPI } from '../../server/reqAPI';
import { abnormalReporting } from '../../server/commonFun';
import utils from "../../lib/utils";
import { Utils } from "../../utils/Utils";

let vCodeIntervalTime = 59; // 发送验证码的间隔时间

class SetPassword extends React.Component {
    state = {
        passwordType: true, // 密码输入框类型
        vCodeCount: 0, // 倒计时
        countryCode: '', // 区号
        phone: '', // 手机号
        vCode: '', // 验证码
        password: '', // 密码
        error: '', // 密码规则检验错误信息
    }

    componentDidMount() {
        this.handleGetSettingData();
    }

    // 获取用户数据
    handleGetSettingData() {
        request(reqAPI.user_info, this.context.user, { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                if (res.code && res.code === 200) {
                    this.setState({
                        phone: res.showPhoneNum || '',
                        countryCode: res.countryCode || '',
                    });
                } else {
                    abnormalReporting({
                        putaoid: this.context.user.putaoid,
                        url: reqAPI.user_info,
                        type: 'data',
                        res
                    });
                }
            });
    }

    clickBackButton = () => {
        window.history.back();
    }

    handleClickPassword = () => {
        this.setState({ passwordType: !this.state.passwordType });
    }

    // 输入框改变（输入验证也在这里）
    changeInputHandler(e, key) {
        e.preventDefault();

        const value = key.indexOf("password") < 0 ? e.target.value.replace(/\D/g, "") : e.target.value;

        this.setState({
            [key]: value,
            error: '',
        });
    }

    // 获取验证码
    handleGetVCode = () => {
        const { countryCode, phone } = this.state;

        request(reqAPI.set_ps_get_vCode, Object.assign({}, this.context.user, { phone, country_code: countryCode }), { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                if (res.code && res.code === 200) {
                    this.handleVCodeTimer();
                } else {
                    utils.showTips(res.msg || '');
                }
            });
    }

    // 验证码倒计时
    handleVCodeTimer = () => {
        this.setState({
            vCodeCount: vCodeIntervalTime,
        }, () => {
            this.vCodeTimer = setInterval(() => {
                if (this.state.vCodeCount >= 1) {
                    this.setState({
                        vCodeCount: this.state.vCodeCount - 1
                    });
                } else {
                    clearInterval(this.vCodeTimer);
                }
            }, 1000);
        });
    }

    // 确认修改
    handleSureSet = () => {
        const { phone, vCode, password, countryCode } = this.state;
        const regPassword = /^[a-zA-Z0-9]{6,20}$/;

        if (this.testInput()) {
            if (!regPassword.test(password)) {
                this.setState({ error: '6-20位，请使用数字、字母或组合' });
                return;
            }

            request(
                reqAPI.set_ps_sure,
                Object.assign(
                    {},
                    this.context.user,
                    { phone, vcode: vCode, country_code: countryCode, pw: password }
                ),
                { method: 'GET' }
            )
                .then(res => res.json())
                .then(res => {
                    console.log(res)
                    if (res.code && res.code === 200) {
                        this.handleLoginOut();
                    } else {
                        utils.showTips(res.msg || '');
                    }
                });
        }
    }

    testInput = hasLength => {
        const { phone, vCode, password } = this.state;
        let result = false;

        if (phone && vCode && vCode.length === 4 && password) {
            if (!hasLength || password.length >= 6) {
                result = true;
            }
        }

        return result;
    }

    // 退出登录
    handleLoginOut = () => {
        Utils.delCookie("putaoid", window.location.hostname, "/");
        Utils.delCookie("token", window.location.hostname, "/");

        window.location = `#/login`;
    }

    render() {
        const { passwordType, phone, vCode, password, vCodeCount, error } = this.state;

        return (
            <StyledSetPassword>
                <BackButton onClick={this.clickBackButton} />
                <Title>设置密码</Title>
                <Wrapper>
                    {/* 用来阻止浏览器自动填入 */}
                    <input type='password' style={{ display: 'none' }} />
                    <InputBox className='icon_phone'>
                        <Input
                            type='text'
                            maxLength={11}
                            placeholder=''
                            value={phone && phone.replace(/^(\d{3})(\d{4})/g, '$1 $2 ')}
                            disabled="disabled"
                        // onChange={e => { this.changeInputHandler(e, 'phone') }}
                        />
                        <SendVCode
                            className={vCodeCount ? 'gray' : ''}
                            onClick={this.handleGetVCode}
                        >
                            {vCodeCount ? `${vCodeCount}s` : '获取验证码'}
                        </SendVCode>
                    </InputBox>
                    <InputBox className='icon_vCode'>
                        <Input
                            id='set_vCode'
                            type='text'
                            maxLength={4}
                            placeholder='请输入验证码'
                            value={vCode}
                            onChange={e => { this.changeInputHandler(e, 'vCode') }}
                        />
                    </InputBox>
                    <InputBox className='icon_lock'>
                        <Input
                            id='set_password'
                            type={passwordType ? 'password' : 'text'}
                            placeholder='请输入新密码'
                            value={password}
                            maxLength={20}
                            onChange={e => { this.changeInputHandler(e, 'password') }}
                        />
                        <EyesIcon
                            onClick={this.handleClickPassword}
                            type={passwordType ? 'password' : 'text'}
                        />
                        {error && <Error>{error}</Error>}
                    </InputBox>
                    <Button
                        active={this.testInput(true)}
                        onClick={this.handleSureSet}
                    >
                        确定修改并重新登录
                    </Button>
                </Wrapper>
            </StyledSetPassword>
        );
    }
}

SetPassword.contextTypes = {
    user: PropTypes.object,
    clearUser: PropTypes.func
}

export default SetPassword;

// 这里的设计图用的是 ipad 的，尺寸为 1680

const StyledSetPassword = styled.div`
    width: 100vw;
    height: 100vh;
    background: #fff;
`;

const BackButton = styled.div`
    position: fixed;
    top: 0.24rem;
    left: 0.64rem;
    width: 0.88rem;
    height: 0.8rem;
    background: url(${require('../../static/img/set_img/icon_back@2x.png')}) no-repeat center;
    background-size: contain;
    cursor: pointer;
    z-index: 10;
`;

const Title = styled.div`
    height: 1.32rem;
    line-height: 1.32rem;
    background: #FFFFFF;
    border-bottom: 2px solid #E5E5EB;
    border-radius: 0px 0px 0.16rem 0.16rem;
    color: #000;
    font-size: 0.52rem;
    text-align: center;
`;

const Wrapper = styled.div`
    width: 6.2rem;
    margin: 1.46rem auto; 
`;

const InputBox = styled.div`
    position: relative;
    width: 100%;
    border-bottom: 1px solid #F5F5F9;
    height: 0.92rem;
    line-height: 0.92rem;
    margin-bottom: 0.35rem;
    padding-left: 0.73rem;

    &.icon_phone {
        background: url(${require('../../static/img/set-password/icon_iphone.png')}) no-repeat 0.09rem center;
        background-size: 0.34rem 0.42rem;
    }

    &.icon_vCode {
        background: url(${require('../../static/img/set-password/icon_vCode.png')}) no-repeat 0.09rem center;
        background-size: 0.34rem 0.42rem;
    }

    &.icon_lock {
        background: url(${require('../../static/img/set-password/icon_lock.png')}) no-repeat 0.09rem center;
        background-size: 0.34rem 0.42rem;
    }
`;

const Input = styled.input`
    border: none;
    padding: 0;
    margin: 0;
    outline-style: none;
    height: 0.8rem;
    font-size: 0.36rem;
    color: #59555F;

    &::-webkit-input-placeholder {
        color: #BDB9C3;
    }

    &:disabled {
        background-color: #fff;
    }
`;

const SendVCode = styled.div`
    position: absolute;
    bottom: 0.31rem;
    right: 0;
    width: 2rem;
    height: 0.3rem;
    line-height: 0.3rem;
    border-left: 1px solid #F5F5F9;
    color: #9B70F4;
    font-size: 0.29rem;
    text-align: right;
    cursor: pointer;

    &.gray {
        color: #BDB9C3;
    }
`;

const EyesIcon = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 0.6rem;
    background: url(${require('../../static/img/set-password/icon_eyes_close.png')}) no-repeat center;
    background-size: 0.39rem 0.17rem;
    cursor: pointer;

    ${props => props.type && props.type === 'text' ? `
         background: url(${require('../../static/img/set-password/icon_eyes_open.png')}) no-repeat center;
         background-size: 0.39rem 0.39rem;
    ` : ``}
`;

const Button = styled.div`
    width: 100%;
    margin-top: 0.59rem;
    border-radius: 0.44rem;
    height: 0.88rem;
    line-height: 0.88rem;
    text-align: center;
    background: #E5E5EB;
    color: #fff;
    font-size: 0.36rem;
    box-shadow: 0px 4px 8px 0px rgba(139, 115, 255, 0.3);
    cursor: pointer;

    ${props => props.active ? `
        background: #8B73FF;
    ` : ``}
`;

const Error = styled.div`
    position: absolute;
    bottom: -0.1rem;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: 0.26rem;
    height: 0.3rem;
    color: #e2750f;
`;


// WEBPACK FOOTER //
// ./src/route/version-3/SetPassword.js